// extracted by mini-css-extract-plugin
export default {"wrapper":"Comment_wrapper__F9UtF","textarea":"Comment_textarea__VqaFU"};